export default "__VITE_ASSET__DyYZrqrN__"